export default __webpack_public_path__ + "static/media/safety-training-icon.07f9a9fa.svg";